import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Lightweight SEO meta tags + Open Graph for sharing on social.
 * Drop into any page. Defaults aimed at Asvasa brand.
 */
const DEFAULT_OG = "https://res.cloudinary.com/dxegjh577/image/upload/asvasa/hero/og.jpg";

export default function SEO({
  title,
  description = "Premium menswear from Ahmedabad — linen and cotton shirts & kurtas, hand-finished in small batches.",
  image = DEFAULT_OG,
  url,
  type = "website",
}) {
  const fullTitle = title ? `${title} · Asvasa` : "Asvasa · Premium menswear from Ahmedabad";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      {image && <meta property="og:image" content={image} />}
      {url && <meta property="og:url" content={url} />}
      <meta property="og:site_name" content="Asvasa" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
}
